<template>
  <div class="case-file-dailog col-block block">
    <div class="sample-file-container col-block">
      <div class="sample-file-title">{{ 'Data Information'/* ___ */ }}</div>
      <div :style="{ height: '15px' }"></div>
      <div class="sample-file-content col-block">
        <template v-if="['fastq'].includes(param.caseData.dataset)">
          <div class="sample-file-info-container row-block">
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 2 }">
              <div class="sample-file-info-title">{{ 'Omics'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.omics || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 3 }">
              <div class="sample-file-info-title">{{ 'Pipeline'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.pipeline || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 3 }">
              <div class="sample-file-info-title">{{ 'Library Type'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.library_type || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 2 }">
              <div class="sample-file-info-title">{{ 'Total Bases'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content" :title="param.caseData.total_bases">{{ param.caseData.total_bases ? fixNumber(param.caseData.total_bases * Math.pow(10, -9), 0.01) + ' G' : '--' }}</div>
            </div>
          </div>
          <div :style="{ height: '15px' }"></div>
          <div class="sample-file-main-field row-block">
            <div class="sample-file-main-container col-block flex-start" :style="{ flex: 1 }">
              <div class="sample-file-main-title">{{ 'Fastq Files'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-list-container col-block">
                <template v-for="(fileGroup, index) in fileGroups">
                  <div class="sample-file-list-block row-block flex-start" :key="index">
                    <div class="sample-file" :style="{ flex: 1 }"><b>{{ 'Set' + fileGroup[0].group.replace(/L/, '') + '-R' + fileGroup[0].read_strand + ': '/* ___ */ }}</b>{{ fileGroup[0].name }}</div>
                    <div class="sample-file" :style="{ flex: 1 }"><b>{{ 'Set' + fileGroup[1].group.replace(/L/, '') + '-R' + fileGroup[1].read_strand + ': '/* ___ */ }}</b>{{ fileGroup[1].name }}</div>
                  </div>
                  <hr v-if="fileGroups[index + 1]" :key="'hr-' + index">
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="sample-file-main-field row-block">
            <div class="sample-file-main-container col-block flex-start" v-for="(file, index) in param.sampleFiles" :key="index" :style="{ flex: 1 }">
              <div class="sample-file-main-title">{{ file.name.includes('bam') ? 'BAM files'/* ___ */ : file.name.includes('vcf') ? 'VCF files'/* ___ */ : 'files'/* ___ */ }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file" :style="{ flex: 1 }">{{ file.name }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <hr class="no-margin">
    <div :style="{ height: '15px' }"></div>
    <div class="analysis-file-container col-block flex-start">
      <div class="analysis-file-block" v-for="(fileType, type, tindex) in param.analysisFiles" :key="tindex">
        <div class="block-content col-block">
          <div class="af-title row-block">
            <div class="row-block">
              <div class="title">{{ type }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="af-container row-block flex-start" v-for="(fileGroup, group, tindex) in fileType" :key="tindex">
            <div class="af-group-title" :style="{ flex: 1 }">{{ (tindex + 1) + '. ' + group }}</div>
            <div class="af-block col-block" :style="{ flex: 1 }">
              <div class="file row-block flex-start" v-for="(file, findex) in fileGroup" :key="findex">
                <a :style="{ flex: 1 }" class="link" :href="API_ROOT + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + $ls.get('userInfo').access_token">{{ file.name }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { API_ROOT } from '../../api/config'
import borCor from '../../components/tool/borCor'
import { sortData, groupBy, fixNumber } from '../../constants/global/util'

export default {
  components: {
    borCor
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    fileGroups () {
      return groupBy(sortData(this.param.sampleFiles, file => file.read_strand), file => file.group)
    },
    // global
    API_ROOT () { return API_ROOT },
    fixNumber () { return fixNumber }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseFile.vue